export const views = {
  monthly: 'monthly',
  daily: 'daily',
  weekly: 'weekly',
}

export const viewOptions = [
  {
    value: views.monthly,
    label: 'Month',
  },
  {
    value: views.weekly,
    label: 'Week',
  },
  {
    value: views.daily,
    label: 'Day',
  },
]

export default views
